import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'relements/build/esm/ui/icon';

import styles from './SmallTalkUserSays.scss';

function SmallTalkUserSays({ sentences }) {
  return (
    <div className={styles.smallTalkUserSays} data-testid="smallTalk-userMessages">
      <div className={styles.smallTalkUserSaysHeader}>
        <Icon src="user-says" className={styles.smallTalkUserSaysHeaderIcon} />
        <div className={styles.smallTalkUserSaysHeaderText}>User Messages</div>
      </div>
      <div className={styles.smallTalkUserSaysBody}>
        {sentences.map((sentence) => (
          <div className={styles.smallTalkUserSaysSentence}>
            {sentence.text}
          </div>
        ))}
      </div>
    </div>
  );
}

SmallTalkUserSays.propTypes = {
  sentences: PropTypes.shape({
    text: PropTypes.string,
    active: PropTypes.bool,
  }),
};

SmallTalkUserSays.defaultProps = {
  sentences: [],
};

export default SmallTalkUserSays;
